import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import {FC} from 'react';
import { CompanyLogo } from '@/app/[locale]/business/components/BarOfCompanies';
import ScrollableList from '@/components/design-system/ScrollableList';

const BarOfBrands: FC = () => {
  const t = useTranslations('business');
  const data = [
    <CompanyLogo logoUrl={`${IMGPW}/logos/fontanafredda.png`} altText="Fontanafredda" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/cadelbosco.png`} altText="Ca' Del Bosco" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/berlucchi.png`} altText="Berlucchi" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/bellavista.png`} altText="Bellavista" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/donnafugata.webp`} altText="Donnafugata" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/ferrari.png`} altText="Ferrari" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/antinori.webp`} altText="Antinori" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/taittinger.png`} altText="Taittinger" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/ghmumm.png`} altText="G.H. Mumm" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/moetchandon.png`} altText="Moët & Chandon" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/allegrini.png`} altText="Allegrini" />,
  ];

  return (
    <div className="section-container text-center mb-12">
      <h2 className="mb-4 font-bold">
        {t('Index.migliori-brand')}
      </h2>
      <ScrollableList
        gap={8}
        autoPlay
        columns={{
          xxl: 5,
          xl: 5,
          lg: 4,
          md: 3,
          sm: 2,
          xs: 'auto',
        }}
        data={data}
        keyExtractor={(elem, index) => index.toString()}
        renderItem={(elem) => elem}
      />
    </div>
  );
};

export default BarOfBrands;
